import App from "@bloglovin/inspire-engine/App";

const isNotLocallyTombstoned = element => element !== null;

export function destinationElementsOf(appName, dynamicComponentId) {
  const app = App.get(appName);
  const dynamicComponentPk = { id: dynamicComponentId };
  app.getFeedStore("DynamicComponent", dynamicComponentPk, "elements").triggerInitialLoad();
  return (app.getFeedItems("DynamicComponent", dynamicComponentPk, "elements") ?? [])
      .map(item => app.getEntity("Element", item.entityPk))
      .filter(isNotLocallyTombstoned);
}
